import React, { Component } from "react";
import { useRef } from "react";
import { checkTranslation, translate } from "../../../utils/useful";
import inputComponents from "../../inputs/inputComponents";
const GhostRowInput = React.forwardRef((props, ref) => {

    let header = props.header;
    const inputRef = useRef('component-' + header.jey)
    let Component = inputComponents[header.type]

    return (
        <div style={{ position: 'absolute', top: 0, left: 0, visibility: 'hidden' }} ref={ref}>
            {header.information?.label ? (
                <div className="w-100 mb-1 text-start">
                    <label className={' text-small mrd-1 mld-1  ' + (header.information?.required ? 'required' : '')}>{checkTranslation(header.information?.label)}</label>
                </div>
            ) : (
                <div className="w-100 mb-1 text-start">
                    <label className={'color-gray-5 text-small mrd-1 mld-1  ' + (header.information?.required ? 'required' : '')}>{translate("Field Name")}</label>
                </div>
            )}

            <div className={"flexc " + (header.information.inputClass ?? (props.inputClass ? props.inputClass : 'default-input-view '))} >
                {Component && (
                    <div className="w-100  p-0" key={header.key}>
                        <Component changeValue={() => { }} data={null} ref={inputRef} header={header} />
                    </div>
                )}
            </div>

            {header.information?.hint && (
                <div className="w-100 mt-1  text-start ">
                    <p className='text-smaller color-gray-2 px-1' >{checkTranslation(header.information?.hint)}</p>
                </div>
            )}
        </div>
    );
})


export default GhostRowInput;